import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import { Button } from "semantic-ui-react";
import { forceValidation } from "../../../shared/validMeReact";
import {
  updateCurrentMenu,
  updateCheckoutPreviousMenu,
} from "../../../../actions/menu";
import {
  menuNamesEnum,
  paymentStatusEnum,
} from "../../../../state/initialState";
import { saveBooking, updateBooking } from "../../../../actions/booking";
import {
  updateCancelAppointmentModalVisibility,
  updateCancelRecurringAppointmentVisibility,
  updateRestoreAppointmentModalVisibility,
  updateStoreCardForLaterModalVisibility,
} from "../../../../actions/menu";
import { updateGlobalErrorMessage } from "../../../../actions/globalError";
import { saveAppointmentDataHandler } from "../../../shared/functions/saveAppointmentDataHandler";
import { updateAppointmentStepData } from "../../../../actions/appointmentStep";
import objectAssign from "object-assign";
import { clone } from "../../../../reducers/helper";

@connect(mapStateToProps)
export default class BottomPanelAppointment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      hoveredSave: false,
      hoveredStoreCardButton: false,
    };
  }

  closeApp = () => {
    let event = new CustomEvent("messageFromUsToParent", {
      detail: {
        action: "close",
      },
    });
    window.dispatchEvent(event);
  };

  dispatchUpdateAppointmentStepData = (appointmentStepData) => {
    this.props.dispatch(updateAppointmentStepData(appointmentStepData));
  };

  updateThisStep = (data) => {
    let newData = "";
    newData = clone(this.props.appointmentStepData);
    newData = objectAssign({}, this.props.appointmentStepData, data);

    //this.dispatchUpdateAppointmentStepData(newData);
  };

  componentWillReceiveProps(props) {
    let {
      appointmentStepData: {
        triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot,
      },
      savingBooking,
      currentBookingId,
      appIsVisible,
      recursiveAppointmentConfirmationModalVisible,
      loadingBooking,
      finishedLoadingServicesAndOrganizationData,
      multiserviceAppointmentConfirmationModalVisible,
      isMultiServiceAppointment,
    } = props;
    let { recurringToggleOn } = this.props.advancedAppointmentStepData;
    let recurringConditions =
      !recursiveAppointmentConfirmationModalVisible && recurringToggleOn;
    let multiServiceConditions =
      isMultiServiceAppointment &&
      !multiserviceAppointmentConfirmationModalVisible;
    if (
      triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot &&
      finishedLoadingServicesAndOrganizationData &&
      !savingBooking &&
      !loadingBooking &&
      currentBookingId &&
      appIsVisible &&
      (recurringConditions || multiServiceConditions)
    ) {
      this.updateThisStep({
        triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot: false,
      });
      if (multiServiceConditions) {
        this.handleSaveClick.bind(this, null, null, props)(); //clicking save by force to trigger save popup.
      } else {
        this.handleSaveClick(); //clicking save by force to trigger save popup.
      }
    }
  }

  handleSaveClick = (event, cb, props) => {
    let {
      appointmentStepData,
      advancedAppointmentStepData,
      bookingOnlyCustomerProfileData,
      currentBookingId,
      advancedAppointmentStepDataFromLastSave,
      isMultiServiceAppointment,
      gotValidOffer,
    } = props || this.props;
    let areThereErrors = forceValidation(
      null,
      null,
      this.props.validationDataGroup
    );

    if (!cb) {
      cb = () => {
        this.closeApp();
      };
    }
    if (!areThereErrors) {
      let forceSave = true;
      let closeWhenSaved = true;

      let savedSnapshot = sessionStorage.getItem(
        "BOOKING_APPOINTMENT_SNAPSHOT"
      );

      // This is to always save the booking profile
      const newAppointmentStepData = objectAssign({}, appointmentStepData, {
        selectedCustomer: {
          address: bookingOnlyCustomerProfileData.address,
          email: bookingOnlyCustomerProfileData.email,
          firstname: bookingOnlyCustomerProfileData.firstName,
          lastname: bookingOnlyCustomerProfileData.lastName,
          phone: bookingOnlyCustomerProfileData.phoneNumber,
        },
        address: bookingOnlyCustomerProfileData.address,
      });

      let currentSnapshot = JSON.stringify({
        appointmentStepData: newAppointmentStepData,
        advancedAppointmentStepData,
      });

      if (savedSnapshot != currentSnapshot || !currentBookingId) {
        //if there are  changes, save
        saveAppointmentDataHandler(
          this.props.dispatch,
          newAppointmentStepData,
          advancedAppointmentStepData,
          currentBookingId,
          advancedAppointmentStepDataFromLastSave,
          cb,
          forceSave,
          isMultiServiceAppointment,
          gotValidOffer,
          closeWhenSaved
        );
      } else {
        this.closeApp(); //save without doing anything if there are no changes so we avoid sending emails
      }
    }
  };

  handleViewCheckoutInvoicesClick = () => {
    this.props.dispatch(
      updateCheckoutPreviousMenu(menuNamesEnum.FIRST_STEP_APPOINTMENT)
    );
    this.props.dispatch(updateCurrentMenu(menuNamesEnum.THIRD_STEP_CHECKOUT));
  };

  handleCheckoutClick = () => {
    let {
      appointmentStepData: {
        selectedCustomer,
        paymentStatus,
        selectedAppointmentStatus,
      },
      currentBookingId,
      appointmentStepData,
      advancedAppointmentStepData,
    } = this.props;
    const { CustomerEmailRequired } = window.APP.LANGUAGE.Errors;
    let savedSnapshot = sessionStorage.getItem("BOOKING_APPOINTMENT_SNAPSHOT");

    let currentSnapshot = JSON.stringify({
      appointmentStepData,
      advancedAppointmentStepData,
    });

    if (selectedCustomer.email && selectedCustomer.email != "") {
      let areThereErrors = forceValidation(
        null,
        null,
        this.props.validationDataGroup
      );
      if (!areThereErrors) {
        this.props.dispatch(
          updateCheckoutPreviousMenu(menuNamesEnum.FIRST_STEP_APPOINTMENT)
        );

        if (savedSnapshot == currentSnapshot && currentBookingId) {
          this.props.dispatch(
            updateCurrentMenu(menuNamesEnum.THIRD_STEP_CHECKOUT)
          );
        } else {
          let cb = () => {
            setTimeout(() => {
              this.props.dispatch(
                updateCurrentMenu(menuNamesEnum.THIRD_STEP_CHECKOUT)
              );
            }, 0); // update in the next step, which will mean that the booking id would be processed and go into the redux store by the time checkout page loads
          };

          let savedSnapshot = sessionStorage.getItem(
            "BOOKING_APPOINTMENT_SNAPSHOT"
          );
          let currentSnapshot = JSON.stringify({
            appointmentStepData,
            advancedAppointmentStepData,
          });
          if (
            (savedSnapshot != currentSnapshot || !currentBookingId) &&
            paymentStatus != paymentStatusEnum.STATUS_PAID &&
            selectedAppointmentStatus.id != 5
          ) {
            //if there are  changes or if its a new booking, save
            this.handleSaveClick(null, cb);
          } else {
            cb();
          }
        }
      }
    } else {
      this.props.dispatch(
        updateGlobalErrorMessage({ message: CustomerEmailRequired })
      );
    }
  };

  handleChoutoutMouseIn = () => {
    this.setState({ hover: true });
  };
  handleCheckoutMouseOut = () => {
    this.setState({ hover: false });
  };

  handleSaveMouseIn = () => {
    this.setState({ hoveredSave: true });
  };
  handleSaveMouseOut = () => {
    this.setState({ hoveredSave: false });
  };

  handleStoreCardMouseIn = () => {
    this.setState({ hoveredStoreCardButton: true });
  };
  handleStoreCardMouseOut = () => {
    this.setState({ hoveredStoreCardButton: false });
  };

  updateCancelAppointmentVisibility = (isVisible) => {
    let { advancedAppointmentStepDataBeforeUserHasMadeAnyChanges } = this.props;
    if (
      advancedAppointmentStepDataBeforeUserHasMadeAnyChanges.recurringToggleOn
    ) {
      this.props.dispatch(
        updateCancelRecurringAppointmentVisibility(isVisible)
      );
    } else {
      this.props.dispatch(updateCancelAppointmentModalVisibility(isVisible));
    }
  };

  updateRestoreAppointmentVisiblity = (isVisible) => {
    this.props.dispatch(updateRestoreAppointmentModalVisibility(isVisible));
  };

  canEditCurrentBooking = () => {
    let { limitedPermissions, currentBookingId } = this.props;
    return (
      limitedPermissions.canEditAllBookings ||
      (limitedPermissions.bookingsEditableByCurrentUser.indexOf(
        currentBookingId
      ) > -1 &&
        currentBookingId)
    );
  };

  canCheckoutCurrentBooking = () => {
    let { currentBookingId, limitedPermissions } = this.props;
    return (
      (limitedPermissions.canCheckoutAllBookings ||
        limitedPermissions.bookingsCheckoutableByCurrentUser.indexOf(
          currentBookingId
        ) > -1) &&
      this.canEditCurrentBooking()
    );
  };

  getCheckoutButton = () => {
    let {
      savingBooking,
      currentBookingId,
      limitedPermissions,
      appointmentStepData: {
        selectedCustomer,
        selectedAppointmentStatus,
        paymentStatus,
      },
      checkoutAppointmentStepData: { invoiceKey },
      gotValidOffer,
    } = this.props;
    let {
      CustomerEmailRequiredHover,
      CannotCheckoutARecurringAppointment,
    } = window.APP.LANGUAGE.Errors;
    let {
      Checkout,
      CheckoutAccessRestrictedMessage,
      BookingCannotBeEditedByCurrentUserMessage,
      NoCheckoutDetailsAvailableForThisBooking,
      OfferPaidForMessage,
      ViewPayment,
    } = window.APP.LANGUAGE.Pages.Appointment;
    let { recurringToggleOn } = this.props.advancedAppointmentStepData;

    let checkoutClasses = "ui left floated button btn-default checkout_btn";

    if (savingBooking) {
      checkoutClasses += " disabled";
    }

    if (paymentStatus == paymentStatusEnum.STATUS_PAID || gotValidOffer) {
      checkoutClasses += " view_payment";
    }

    let checkoutAppointmentButton = "";

    let checkoutButtonWithMessageOnHover = false;
    let checkoutMessage = "";
    let action = "";

    if (selectedAppointmentStatus.id == 5 && !invoiceKey) {
      checkoutButtonWithMessageOnHover = true;
      checkoutMessage = NoCheckoutDetailsAvailableForThisBooking;
    } else if (gotValidOffer) {
      checkoutButtonWithMessageOnHover = true;
      checkoutMessage = OfferPaidForMessage;
    } else if (
      !selectedCustomer ||
      !selectedCustomer.email ||
      selectedCustomer.email == ""
    ) {
      checkoutButtonWithMessageOnHover = true;
      checkoutMessage = CustomerEmailRequiredHover;
    } else if (
      (selectedCustomer.firstname || selectedCustomer.lastname) &&
      this.canCheckoutCurrentBooking() &&
      !recurringToggleOn &&
      limitedPermissions.canViewAndEditCheckoutInvoicesForAllBookings
    ) {
      action = this.handleCheckoutClick;
    } else if (recurringToggleOn) {
      checkoutButtonWithMessageOnHover = true;
      checkoutMessage = CannotCheckoutARecurringAppointment;
    } else if (
      limitedPermissions.canViewAndEditCheckoutInvoicesForAllBookings &&
      invoiceKey
    ) {
      action = this.handleViewCheckoutInvoicesClick;
    } else if (
      !limitedPermissions.canViewAndEditCheckoutInvoicesForAllBookings
    ) {
      checkoutButtonWithMessageOnHover = true;
      checkoutMessage = CheckoutAccessRestrictedMessage;
    } else if (
      !this.canCheckoutCurrentBooking() &&
      limitedPermissions.canViewAndEditCheckoutInvoicesForAllBookings &&
      !invoiceKey
    ) {
      checkoutButtonWithMessageOnHover = true;
      checkoutMessage = NoCheckoutDetailsAvailableForThisBooking;
    }
    if (checkoutButtonWithMessageOnHover) {
      checkoutAppointmentButton = (
        <div className="tooltip-container">
          <div
            onMouseOver={this.handleChoutoutMouseIn}
            onMouseOut={this.handleCheckoutMouseOut}
            className="ui disable right floated button btn-default checkout_btn"
          >
            {Checkout}
          </div>
          {this.state.hover ? (
            <div className="booking_tooltip_text">{checkoutMessage}</div>
          ) : (
            ""
          )}
        </div>
      );
    } else {
      checkoutAppointmentButton = (
        <div
          onClick={action}
          data-group={this.props.validationDataGroup}
          className={checkoutClasses}
          tabIndex="0"
        >
          {paymentStatus == paymentStatusEnum.STATUS_PAID || gotValidOffer
            ? ViewPayment
            : Checkout}
        </div>
      );
    }

    return checkoutAppointmentButton;
  };

  solvedAllClashes = () => {
    let {
      futureAppointmentClashesResolved,
      futureAppointmentClashes,
    } = this.props.advancedAppointmentStepData;

    let processedAppointments =
      futureAppointmentClashesResolved.filter((x) => (x || {}).processed) || [];

    return futureAppointmentClashes.length == processedAppointments.length;
  };

  handleTabReset = (e) => {
    if (e.keyCode === 9 && !e.shiftKey) {
      let foundNavigationItemsAvailable = document.querySelectorAll(
        '[tabindex="0"]'
      );
      if (foundNavigationItemsAvailable && foundNavigationItemsAvailable[0]) {
        foundNavigationItemsAvailable[0].focus();
      }
    }
  };

  updateStoreCardForLaterModalVisibility = (isVisible) => {
    this.props.dispatch(updateStoreCardForLaterModalVisibility(isVisible));
  };

  getStoreCardButton = () => {
    let {
      savingBooking,
      appointmentStepData: {
        selectedAppointmentStatus,
        selectedCustomer,
        paymentsEnabled,
      },
    } = this.props;
    let { StoreCardButtonText } = window.APP.LANGUAGE.Pages.Appointment;
    let {
      CannotStoreCardForARecurringAppointment,
    } = window.APP.LANGUAGE.Errors;
    let {
      CannotStoreCardWithoutCustomerSelected,
      NoAccessToSaveBookingOrCheckoutRequiredToSaveCard,
      PaymentsMustBeEnabledToStoreCard,
    } = window.APP.LANGUAGE.Errors;
    let { recurringToggleOn } = this.props.advancedAppointmentStepData;

    let storeCardClasses =
      "ui right floated   store-credit-card-button centered";

    if (savingBooking) {
      storeCardClasses += " loading disabled";
    }

    if (
      selectedAppointmentStatus.id == 5 ||
      selectedAppointmentStatus.id == 6
    ) {
      storeCardClasses += " disabled";
    }

    let storeCardButton = (
      <a
        onClick={this.updateStoreCardForLaterModalVisibility.bind(this, true)}
        data-group={this.props.validationDataGroup}
        className={storeCardClasses}
        tabIndex="0"
        onKeyDown={this.handleTabReset}
      >
        {StoreCardButtonText}
      </a>
    );

    let noAccessMessage;
    if (!paymentsEnabled) {
      noAccessMessage = PaymentsMustBeEnabledToStoreCard;
    } else if (
      !this.canEditCurrentBooking() ||
      !this.canCheckoutCurrentBooking()
    ) {
      noAccessMessage = NoAccessToSaveBookingOrCheckoutRequiredToSaveCard;
    } else if (
      !selectedCustomer ||
      !selectedCustomer.email ||
      selectedCustomer.email == ""
    ) {
      noAccessMessage = CannotStoreCardWithoutCustomerSelected;
    } else if (recurringToggleOn) {
      noAccessMessage = CannotStoreCardForARecurringAppointment;
    }

    if (noAccessMessage) {
      storeCardClasses += " disable";
      storeCardButton = (
        <div className="tooltip-container centered">
          <a
            onMouseOver={this.handleStoreCardMouseIn}
            onMouseOut={this.handleStoreCardMouseOut}
            className={storeCardClasses}
          >
            {StoreCardButtonText}
          </a>
          {this.state.hoveredStoreCardButton ? (
            <div className="booking_tooltip_text ">{noAccessMessage}</div>
          ) : (
            ""
          )}
        </div>
      );
    }

    return storeCardButton;
  };

  render() {
    let {
      savingBooking,
      currentBookingId,
      limitedPermissions,
      appointmentStepData: {
        selectedAppointmentStatus,
        isNewBooking,
        selectedCustomer,
        multiServiceList,
      },
      checkoutAppointmentStepData: { invoiceKey },
      gotValidOffer,
    } = this.props;
    let {
      CustomerEmailRequiredHover,
      CannotCheckoutARecurringAppointment,
      BookingCannotBeSavedUntilClashesAreResolvedMessage,
    } = window.APP.LANGUAGE.Errors;
    let {
      CancelAppointment,
      RestoreAppointment,
      Checkout,
      Save,
      CheckoutAccessRestrictedMessage,
      BookingCannotBeEditedByCurrentUserMessage,
      NoCheckoutDetailsAvailableForThisBooking,
    } = window.APP.LANGUAGE.Pages.Appointment;
    let { recurringToggleOn } = this.props.advancedAppointmentStepData;

    let cancelAppointmentButton = "";
    if (
      selectedAppointmentStatus.id == 5 ||
      selectedAppointmentStatus.id == 6
    ) {
      cancelAppointmentButton = (
        <a
          className="ui left floated  booking_cancel "
          tabIndex="0"
          onClick={() => this.updateRestoreAppointmentVisiblity(true)}
        >
          {RestoreAppointment}
        </a>
      );
    } else if (
      !currentBookingId ||
      (!limitedPermissions.canEditAllBookings &&
        limitedPermissions.bookingsEditableByCurrentUser.indexOf(
          currentBookingId
        ) < 0 &&
        currentBookingId) ||
      selectedAppointmentStatus.id == 5
    ) {
      cancelAppointmentButton = (
        <a className="ui left floated  booking_cancel disabled">
          {CancelAppointment}
        </a>
      );
    } else {
      cancelAppointmentButton = (
        <a
          className="ui left floated  booking_cancel "
          tabIndex="0"
          onClick={() => this.updateCancelAppointmentVisibility(true)}
        >
          {CancelAppointment}
        </a>
      );
    }

    let saveClasses = "ui right floated button btn-default save-appointment";

    if (savingBooking) {
      saveClasses += " loading disabled";
    }

    if (
      selectedAppointmentStatus.id == 5 ||
      selectedAppointmentStatus.id == 6
    ) {
      saveClasses += " disabled";
    }

    let saveButton = "";

    if (
      !limitedPermissions.canEditAllBookings &&
      limitedPermissions.bookingsEditableByCurrentUser.indexOf(
        currentBookingId
      ) < 0 &&
      currentBookingId &&
      !savingBooking
    ) {
      // if the user cannot edit the currently opened booking, cannot edit profile
      saveClasses += " disable";
      saveButton = (
        <div className="tooltip-container">
          <div
            onMouseOver={this.handleSaveMouseIn}
            onMouseOut={this.handleSaveMouseOut}
            className={saveClasses}
          >
            {Save}
          </div>
          {this.state.hoveredSave ? (
            <div className="booking_tooltip_text savebtn">
              {BookingCannotBeEditedByCurrentUserMessage}
            </div>
          ) : (
            ""
          )}
        </div>
      );
    } else if (!this.solvedAllClashes()) {
      saveClasses += " disable";
      saveButton = (
        <div className="tooltip-container">
          <div
            onMouseOver={this.handleSaveMouseIn}
            onMouseOut={this.handleSaveMouseOut}
            className={saveClasses}
          >
            {Save}
          </div>
          {this.state.hoveredSave ? (
            <div className="booking_tooltip_text">
              {BookingCannotBeSavedUntilClashesAreResolvedMessage}
            </div>
          ) : (
            ""
          )}
        </div>
      );
    } else {
      saveButton = (
        <div
          onClick={this.handleSaveClick}
          data-group={this.props.validationDataGroup}
          className={saveClasses}
          tabIndex="0"
          onKeyDown={this.handleTabReset}
        >
          {Save}
        </div>
      );
    }

    return (
      <div className="ui clearing aligned  booking_footer">
        {cancelAppointmentButton}
        <div className="action_buttons">
          {this.getStoreCardButton()}
          {this.getCheckoutButton()}
          {saveButton}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    savingBooking: state.bookingReducer.savingBooking,
    currentBookingId: state.bookingReducer.currentBookingId,
    isMultiServiceAppointment: state.bookingReducer.isMultiServiceAppointment,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    gotValidOffer: state.bookingReducer.gotValidOffer,
    advancedAppointmentStepDataBeforeUserHasMadeAnyChanges:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataBeforeUserHasMadeAnyChanges,
    finishedLoadingServicesAndOrganizationData:
      state.appointmentStepReducer.finishedLoadingServicesAndOrganizationData,
    loadingBooking: state.bookingReducer.loadingBooking,
    recursiveAppointmentConfirmationModalVisible:
      state.menuReducer.recursiveAppointmentConfirmationModalVisible,
    appIsVisible: state.appStatusReducer.appIsVisible,
    multiserviceAppointmentConfirmationModalVisible:
      state.menuReducer.multiserviceAppointmentConfirmationModalVisible,
    showCheckoutAfterSave: state.bookingReducer.showCheckoutAfterSave,
    checkoutAppointmentStepData:
      state.appointmentCheckoutReducer.checkoutAppointmentStepData,
    advancedAppointmentStepDataFromLastSave:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataFromLastSave,
    advancedAppointmentStepData:
      state.advancedAppointmentStepReducer.advancedAppointmentStepData,
    bookingOnlyCustomerProfileData:
      state.customerProfileReducer.bookingOnlyCustomerProfileData,
  };
}
